export default function Gallery() {
  const photos = [
    {
      alt: "Réparation crémone de fenêtre Strasbourg par technicien DF PRO",
      prompt: "A professional technician replacing a window cremone lock mechanism on a white PVC window inside a French home, close-up on hands removing the old metal hardware from the window frame, warm natural lighting, clean interior background, professional repair service, soft warm tones, photorealistic",
      w: 600,
      h: 400,
      seq: "crem1",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/b304ac9723d0b436aa765e38a4e8d0e3.webp",
      label: "Réparation crémone de fenêtre Strasbourg par technicien DF PRO",
    },
    {
      alt: "Technicien remplaçant une crémone à Schiltigheim, Bas-Rhin",
      prompt: "A professional technician installing a new window cremone lock mechanism, showing the metal rods and gears being inserted into the window frame, indoor scene in a French home, bright natural light, clean interior, professional service, photorealistic, warm tones",
      w: 600,
      h: 400,
      seq: "crem2",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/edebf18dc3d9b4b98e18d6cbfa28134c.png",
      label: "Technicien remplaçant une crémone à Schiltigheim, Bas-Rhin",
    },
    {
      alt: "Crémone défectueuse démontée à Haguenau, prête au remplacement",
      prompt: "Close-up of a disassembled broken window cremone lock mechanism laid on a work surface next to professional tools, showing the damaged metal parts and gears, clean white background, warm natural lighting, photorealistic, professional repair service",
      w: 600,
      h: 400,
      seq: "crem3",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/7d120bf9097dd7f7a6898db24726593a.jpeg",
      label: "Crémone défectueuse démontée à Haguenau, prête au remplacement",
    },
    {
      alt: "Nouvelle crémone installée sur fenêtre PVC à Strasbourg",
      prompt: "A professional technician testing a newly installed window cremone lock mechanism by turning the handle on a modern white PVC window, French home interior, bright natural light, clean background, professional repair service, photorealistic, warm tones",
      w: 600,
      h: 400,
      seq: "crem4",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/6d237f782373e8b9b4c897af9248880c.webp",
      label: "Nouvelle crémone installée sur fenêtre PVC à Strasbourg",
    },
    {
      alt: "Technicien DF PRO vérifiant les points de verrouillage à Illkirch",
      prompt: "A professional technician checking the locking points of a window cremone mechanism with a specialized tool, close-up on the window frame and hardware, bright natural lighting, clean modern interior, professional repair service, photorealistic, warm tones",
      w: 600,
      h: 400,
      seq: "crem5",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/331449d79b2de3feb0e3a93000c0e561.jpeg",
      label: "Technicien DF PRO vérifiant les points de verrouillage à Illkirch",
    },
    {
      alt: "Fenêtre réparée avec crémone neuve dans le Bas-Rhin",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/2f2dd77280f03252099b15c689ab9334.jpeg",
      w: 600,
      h: 400,
      seq: "crem6",
    },
  ];

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Galerie de réalisations
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum">
            Nos <span className="font-serif italic">interventions</span> sur crémone
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {photos.map((p) => (
            <div
              key={p.seq}
              className="rounded-2xl overflow-hidden border border-rose-200 bg-rose-50"
            >
              <img
                src={p.src || `https://readdy.ai/api/search-image?query=${encodeURIComponent(p.prompt)}&width=${p.w}&height=${p.h}&seq=${p.seq}&orientation=landscape`}
                alt={p.alt}
                className="w-full h-[260px] object-cover object-top"
              />
              <div className="px-4 py-3">
                <p className="text-xs text-plum-dark/60 italic">{p.label || "[PHOTO]"}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}